module.exports = __webpack_public_path__ + "img/liquid.48cabeb4.png";